import { SVGProps } from "react"
const MapIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.1475 3.90039L10.1572 3.90234L10.3018 3.92871C10.3542 3.93818 10.4104 3.94859 10.4668 3.95996C10.5227 3.97123 10.5801 3.98425 10.6357 3.99902L10.7939 4.0498L10.7959 4.05078L15.832 6.17676L20.8105 3.97949V3.98047C20.8366 3.96476 20.8662 3.94586 20.8975 3.93164C20.9336 3.91526 20.9782 3.90048 21.0273 3.90039C21.3357 3.90039 21.5996 4.21374 21.5996 4.60742V16.9639C21.5996 17.2 21.5188 17.4408 21.3975 17.6445C21.2764 17.8478 21.11 18.0232 20.9287 18.123L20.9189 18.1289V18.1279L16.4619 19.9854H16.4609C16.2689 20.0628 15.9896 20.0996 15.833 20.0996C15.7387 20.0996 15.6226 20.0909 15.5107 20.0723C15.4001 20.0538 15.2856 20.0242 15.1992 19.9824V19.9814L10.166 17.8232L5.16016 20.0557L5.15918 20.0547C5.07712 20.0999 4.99663 20.0996 4.94238 20.0996C4.63424 20.0994 4.40045 19.8222 4.40039 19.4287V7.07129C4.40042 6.83746 4.47215 6.59782 4.58594 6.39355C4.69952 6.18976 4.85917 6.01267 5.04199 5.91211L5.05176 5.90723L9.50879 4.05078L9.51367 4.04785L9.54688 4.1416L9.51465 4.04883C9.71574 3.9793 9.93943 3.90051 10.1367 3.90039H10.1475ZM16.4053 7.38477V18.5986L20.4844 16.8623L20.4551 5.54785L16.4053 7.38477ZM10.7393 16.6475L15.2607 18.5977V7.38672L10.7393 5.4375V16.6475ZM5.48535 7.17285L5.51367 18.4883L9.59473 16.6494V5.43652L5.48535 7.17285Z"
      fill="#6F6F6F"
      stroke="#6F6F6F"
      stroke-width="0.2"
    />
  </svg>
)
export default MapIcon
